<div class="page-progress" [style.width]="progress + '%'"></div>
